module.exports = __webpack_public_path__ + "static/media/zucchini.b0eb21ff.jpg";